import styled from "@emotion/styled";

export const CheckListContainer = styled.div`
  background: rgb(var(--colour-static-light-grey, 245, 245, 245));
  padding: 10px;
`;
